export default __webpack_public_path__ + "static/hurricane2-fa15ed409b7aa0becd96b3a55e30549d.png";